<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Contents">Contents</h2>
<p class="firstverse"><a href="#/Text/Foreword"><i>Foreword by J. I. Packer</i></a></p>
<p class="firstverse"><a href="#/Text/Preface"><i>Preface to the Expanded Edition</i></a></p>
<p class="firstverse"><a href="#/Text/Preface2"><i>Preface to the Original Edition</i></a></p>
<blockquote>
<p class="firstverse"><a href="#/Text/ch1">1: Why Study the Bible?</a></p>
<p class="firstverse"><span href="#/Text/ch2" title="Link target outside of Sample">2: Personal Bible Study and Private Interpretation</span></p>
<p class="firstverse"><span href="#/Text/ch3" title="Link target outside of Sample">3: Hermeneutics: The Science of Interpretation</span></p>
<p class="firstverse"><span href="#/Text/ch4" title="Link target outside of Sample">4: Practical Rules for Biblical Interpretation</span></p>
<p class="firstverse"><span href="#/Text/ch5" title="Link target outside of Sample">5: Culture and the Bible</span></p>
<p class="firstverse"><span href="#/Text/ch6" title="Link target outside of Sample">6: Practical Tools for Bible Study</span></p>
</blockquote>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="firstverse"><span href="#/Text/Glossary" title="Link target outside of Sample"><i>Glossary</i></span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="firstverse"><span href="#/Text/MoreTitlesfromIVP" title="Link target outside of Sample"><i>More Titles from InterVarsity Press</i></span></p>
<p class="firstverse"><span href="#/Text/copyright" title="Link target outside of Sample"><i>Copyright</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?40a57e33